import {
  ArrowCollapseAllFilled,
  ArrowExpandAllFilled,
} from "@fluentui/react-icons";
import {
  MenuButton,
  MenuButtonProps,
  useRichTextEditorContext,
} from "mui-tiptap";

export interface MenuButtonCollapseHeadingProps extends Partial<MenuButtonProps> {
  defaultopen?: string;
}

export default function MenuButtonCollapseHeading(
  props: MenuButtonCollapseHeadingProps
) {
  const { defaultopen } = props;

  const shouldBeOpen = defaultopen === "true";

  const editor = useRichTextEditorContext();
  return (
    <MenuButton
      tooltipLabel={
        shouldBeOpen
          ? "Collapse Heading (Default Open)"
          : "Collapse Heading (Default Closed)"
      }
      IconComponent={({ className }: { className: string }) =>
        shouldBeOpen ? (
          <ArrowExpandAllFilled className={className} />
        ) : (
          <ArrowCollapseAllFilled className={className} />
        )
      }
      disabled={
        !editor?.isEditable ||
        !editor.can().toggleCollapsableHeading({
          defaultOpen: shouldBeOpen,
        })
      }
      onClick={() =>
        editor
          ?.chain()
          .focus()
          .toggleCollapsableHeading({
            defaultOpen: shouldBeOpen,
          })
          .run()
      }
      {...props}
    />
  );
}
